import type { ActorsQueryParams } from "./useActorsQuery";
import type { ActorTransactionsQueryParams } from "./useActorTransactionsQuery";

export const ACTORS_QUERY_KEYS = {
  all: ["ACTORS"] as const,
  list: (params: ActorsQueryParams) =>
    [...ACTORS_QUERY_KEYS.all, "LIST", params] as const,
  detail: (actorID: string) =>
    [...ACTORS_QUERY_KEYS.all, "DETAIL", actorID] as const,
  priceCategories: (actorID: string) =>
    [...ACTORS_QUERY_KEYS.all, "PRICE_CATEGORIES", actorID] as const,
  documents: (actorID: string) =>
    [...ACTORS_QUERY_KEYS.all, "DOCUMENTS", actorID] as const,
  transactions: (actorID: string, params: ActorTransactionsQueryParams) =>
    [...ACTORS_QUERY_KEYS.all, "TRANSACTIONS", actorID, params] as const,
} as const;
